module.exports = new __parcel__URL__("shridhar.8fd12453.png").toString();